<template>

 <div class="sy-region-tree-cascade" :style="{height: height + 'px'}">
    <tree-cascade-selector
      v-bind="{...$props, ...$attrs}"
      :size="size"
      :height="height"
      :width="width"
      :fixHeight="fixHeight"
      :placeholder="placeholder"
      :data="data"
      :selectedKeys.sync="selectedIds"
      :multiple="true"
      :props="defaultProps"
      :selectedTagsMaxHeight="140"
      :layerWidth="160"
      @change="change">
    </tree-cascade-selector>
  </div>
</template>

<script>
  import api from './api.js'
  import GetData from '../../../../utils/response'
  import TreeCascadeSelector from '../../../../../../basis/cascade-selector'
  export default {
    name: 'region-tree-cascade',
    components: {
      TreeCascadeSelector
    },
    props: {
      // 是否需要全国
      wholeCountry: {
        type: Boolean,
        default: false
      },
      // 第一次回填
      selectedIds: {
        type: Array,
        default: () => []
      },
      // 设定宽度
      width: {
        type: String,
        default: '340'
      },
      // 设定宽度
      size: {
        type: String,
        default: 'mini'
      },
      placeholder: {
        type: String,
        default: '请选择地区'
      },
      // 设定高度
      height: {
        type: String,
        default: function () {
          if (this.size === 'mini') {
            return 30
          }
          return '40'
        }
      },
      api: {
        type: Object,
        default () {
          return {
            tree: api.getCityTree
          }
        }
      }
    },
    created () {
      let regionData = this.getItem('regionData')
      if (regionData) {
        let data = JSON.parse(regionData)
        this.hasWholeCountry(data)
      } else {
        this.getData()
      }
    },
    data () {
      console.log('data', this.selectedIds)
      return {
        fixHeight: true,
        defaultProps: {
          label: 'name',
          children: 'childList'
        },
        data: []
      }
    },
    methods: {
      getItem (key) {
        return window.localStorage.getItem(key)
      },
      setItem (key, value) {
        window.localStorage.setItem(key, value)
      },
      hasWholeCountry (areaList) {
        if (this.wholeCountry) {
          this.data = [{
            id: '00',
            name: '全国',
            parent: {
              id: null,
              name: null
            },
            childList: areaList
          }]
        } else {
          this.data = areaList
        }
      },
      handleData (areaList = []) {
        const _areaList = []
        areaList.forEach((ele, index) => {
          let obj = {
            id: ele.cityCode,
            name: ele.name,
            parent: {
              id: null,
              name: null
            },
            childList: []
          }
          ele.children.forEach((item) => {
            obj.childList.push({
              id: item.cityCode,
              name: item.name,
              parent: {
                id: ele.cityCode,
                name: ele.name
              },
              childList: []
            })
          })
          _areaList.push(obj)
        })
        return _areaList
      },
      async getData () {
        const data = await GetData(this.api.tree)
        if (data.isOk) {
          let areaList = this.handleData(data.content)
          this.setItem('regionData', JSON.stringify(areaList))
          this.hasWholeCountry(areaList)
        }
      },
      change (dataArr) {
        this.$emit('updateArea', dataArr.simple, this.data)
      }
    }
  }
</script>
